import React, { useEffect, useState } from "react";
import { DefaultButton, Dialog, DialogFooter, PrimaryButton } from "@fluentui/react"

const TabChangedDialog = ({showDialog, onSaveDialog = () => false, onDiscardDialog = () => false, onCancelDialog = () => false, isSaveEnabled}) => {

    const [showConfDialog, setShowConfDialog] = useState()
    const [isSaveEnabledInt, setIsSaveEnabledInt] = useState()

    useEffect(() => {
      setShowConfDialog(showDialog)
    }, [showDialog])

    useEffect(() => {
        setIsSaveEnabledInt(isSaveEnabled)
    }, [isSaveEnabled])
    

    const onDismissDialog = () => {
        setShowConfDialog(false)
        onCancelDialog()
    }

    return (
        <Dialog 
            hidden={!showConfDialog}
            isBlocking={true}
            maxWidth={600}
            onDismiss={onDismissDialog}
        >
            <div style={{margin: '10px 0 20px'}}>You have unsaved changes in your form, what would you like to do?</div>
            <DialogFooter>
                <PrimaryButton onClick={onSaveDialog} text="Save" disabled={!isSaveEnabledInt} />
                <DefaultButton onClick={onDiscardDialog} text="Discard" />
                <DefaultButton onClick={onCancelDialog} text="Cancel" />
            </DialogFooter>
        </Dialog>
    )
}

export default TabChangedDialog


// WEBPACK FOOTER //
// ./src/components/EditSite/TabChangedDialog.js